import { Accordion } from './modules/accordion';
import { Gallery } from './modules/gallery';
import { VouchersCarousel } from './modules/vouchers-carousel';
import { FullBleedImage } from './modules/fullBleedImagesIE';
import { thumbnailCheck } from './modules/thumbnail-check';
import { nodeListToArray } from './helpers/nodeListToArray';
import { SvgSprite } from './modules/svg-loader';
import { Modal } from './modules/modal';
import { BlockAnimation } from './modules/block-animation';
import { mainNavigation } from './modules/main-navigation';
import { mobileNavigation } from './modules/mobile-navigation';
import { siteSearch } from './modules/site-search';
import { footerNavigation } from './modules/footer-navigation';
import isTouchDevice from './modules/is-touch';
import { globalAlert } from './modules/global-alert';
import { embeddedAudio } from './modules/embeddedAudio';
import { InitializeGiftCertificatePage } from './modules/gift-certificate';
import { Reveal } from './modules/reveal';
import { Tabs } from './modules/tabs';
import { Stepper } from './modules/stepper';


(() => {
    //Global Alert
    globalAlert();
    // Embedded Audio
    embeddedAudio();

    // SVG Sprite Inject
    new SvgSprite('/Static/img/adage-sprite.svg');

    // Block animations
    new BlockAnimation();

    // Remove Youtube Default thumbnail with 2s timeout
    new thumbnailCheck();


    // Accordion Init
    const accordions = nodeListToArray(document.querySelectorAll('[data-accordion-list]'));
    accordions.forEach(accordion => {
        new Accordion({
            container: accordion
        });
    });

    //Footer Navigation Init
    const footerNav = document.getElementsByClassName('concert-landing-nav-list-link');
    let footerNavElement = new footerNavigation(footerNav as any);



    //Main navigation init
    const mainNav = document.querySelector('nav.nav');
    let navElement = new mainNavigation(mainNav as HTMLElement);

    //Mobile navigation init
    const mobileNav = document.querySelector('nav.mobile-nav');
    let mobileNavElement = new mobileNavigation(mobileNav as HTMLElement);

    new siteSearch();

    // Fix images in IE that must be full-bleed
    let fullBleedImages = nodeListToArray(document.querySelectorAll('[data-full-bleed-image] img'));
    fullBleedImages.forEach(imageEl => {
        new FullBleedImage(imageEl);
    });


    // Gallery Init
    // Note: it is recommended to use loop: false when creating a gallery with videos at the beginning/end because of duplicated slides.
    let galleryClass = 'single-item-gallery';
    let galleries = nodeListToArray(document.querySelectorAll('[data-gallery]'));
    galleries.forEach((gallery, index) => {
        gallery.classList.add(`${galleryClass}-${index}`);
        new Gallery({
            containerClass: `${galleryClass}-${index}`,
            slidesPerView: 1
        });
    });

    let resgalleryClass = 'responsive-items-gallery';
    let resgalleries = nodeListToArray(document.querySelectorAll('[data-gallery-responsive]'));
    resgalleries.forEach((gallery, index) => {
        const galleryOptions = JSON.parse(gallery.getAttribute('data-gallery-options'));
        gallery.classList.add(`${resgalleryClass}-${index}`);
        new Gallery({
            containerClass: `${resgalleryClass}-${index}`,
            slidesPerView: galleryOptions.slidesPerView,
            spaceBetween: galleryOptions.spaceBetween,
            slidesPerGroup: 1,
            loop: galleryOptions.loop,
            watchOverflow: true,
            breakpoints: galleryOptions.breakpoints,
            freeMode: !!galleryOptions.freeMode,
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            autoplay: galleryOptions.autoplay
        })
    });

    let vouchersgalleryClass = 'vouchers-items-gallery';
    let vouchersgalleries = nodeListToArray(document.querySelectorAll('[data-gallery-vouchers]'));
    vouchersgalleries.forEach((gallery, index) => {
        const galleryOptions = JSON.parse(gallery.getAttribute('data-gallery-options'));
        gallery.classList.add(`${vouchersgalleryClass}-${index}`);
        new VouchersCarousel({
            containerClass: `${vouchersgalleryClass}-${index}`,
            slidesPerView: 'auto',
            spaceBetween: 15,
            slidesPerGroup: 1,
            watchOverflow: true,
            autoplay: false
        })
    });

    // Video Modals Init
    let modals = nodeListToArray(document.querySelectorAll('[data-modal]'));
    modals.forEach(modal => {
        new Modal(modal);
    });

    function resetModalState(modal) {
        let ticketCheckboxes = nodeListToArray(modal.querySelectorAll('input[name="tickets"]'));
        if (ticketCheckboxes && ticketCheckboxes.length > 0) {
            ticketCheckboxes.forEach((checkbox) => {
                let performanceId = checkbox.getAttribute("data-performance");
                let submitButton = document.getElementById("donateSubmit_" + performanceId) as HTMLInputElement;
                let totalEl = document.getElementById("total_" + performanceId);
                checkbox.checked = false;
                if (submitButton)
                    submitButton.disabled = true;

                if (totalEl)
                    totalEl.innerText = "";
            });
        }
    }

    let donateModals = nodeListToArray(document.querySelectorAll("[data-donate-modal]"));
    let returnModals = nodeListToArray(document.querySelectorAll("[data-return-modal]"));
    let transferModals = nodeListToArray(document.querySelectorAll("[data-transfer-modal]"));
    let transferDisclaimerModals = nodeListToArray(document.querySelectorAll("[data-disclaimer-modal]"));

    donateModals.forEach((modal) => {
        let donateModal = new Modal(modal); //init a11y-dialog
        donateModal.modal.on("hide", () => { resetModalState(modal) });
    });

    returnModals.forEach((modal) => {
        let donateModal = new Modal(modal); //init a11y-dialog
        donateModal.modal.on("hide", () => { resetModalState(modal) });
    });

    transferModals.forEach((modal) => {
        let donateModal = new Modal(modal); //init a11y-dialog
        donateModal.modal.on("hide", () => { resetModalState(modal) });
    });

    transferDisclaimerModals.forEach((modal) => {
        let donateModal = new Modal(modal); //init a11y-dialog
        donateModal.modal.on("hide", () => { resetModalState(modal) });
    });

    const reveals = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]')) as HTMLElement[];
    reveals.forEach(reveal => {
        new Reveal(reveal);
    });

 // Tabs Init
 const tabs = nodeListToArray(document.querySelectorAll('[data-tabs-container]'));
 tabs.forEach(tabGroup => {
     new Tabs({ container: tabGroup as HTMLElement });
 });

 const steppers = Array.prototype.slice.call(document.querySelectorAll('[data-stepper]')) as HTMLElement[];
 steppers.forEach(stepper => {
     new Stepper(stepper, 1);
 });

    InitializeGiftCertificatePage();



})();
